import { SET_THEME } from "./themes.action.types";

export const setThemeAction = (payload) => ({
  type: SET_THEME,
  payload
});
